@if (fields.length) {
  <div class="si-filter-bar">
    @for (field of fields; track field.key) {
      <div class="si-filter-bar__field">
        <lib-gung-input-multi-select
          [label]="field.label"
          [optionsList]="field.options"
          [singleSelection]="true"
          [showEmptyIds]="true"
          [showId]="false"
          [enableLazyLoad]="true"
          [lazyLoadLimit]="50"
          previewField="name"
          dropdownCustomClass="si-filter-bar__dropdown"
          (selectedValues)="select(field.key, $event)"
        ></lib-gung-input-multi-select>
      </div>
    }
  </div>
}
